import React from 'react';
import { RGBColor, ColorResult, SketchPicker } from 'react-color';

type Props = {
  value: string | RGBColor;
  onChange: (value: string | RGBColor) => void;
};

const ColorPicker = ({ value, onChange }: Props): React.ReactElement => {
  return (
    <SketchPicker
      color={value}
      onChange={(color: ColorResult) => {
        onChange(color.rgb);
      }}
      onChangeComplete={(color: ColorResult) => {
        onChange(color.rgb);
      }}
    />
  );
};

export default ColorPicker;
